import { type ReactElement } from "react";
import { useDarkMode, useLanguage } from "@/context";
import { type Project } from "@/models";
import { t } from "@/data";
import { SiGithub } from "react-icons/si";

interface CardProps {
  data: Project;
}

export const Card = ({ data }: CardProps): ReactElement => {
  const { modeClass } = useDarkMode();
  const { lang } = useLanguage();

  return (
    <a
      href={data.url}
      target="_blank"
      rel="noopener noreferrer"
      className={`card ${modeClass}`}
    >
      <div className="btn-header" aria-hidden="true">
        <SiGithub />
      </div>
      <div className="title">{data.name}</div>
      <div className="description">{data.description}</div>
      <div className="technologies" aria-label={t(lang, "techUsed")}>
        {data.technologies.map((technology, index) => (
          <div className="badge" key={index}>
            {technology}
          </div>
        ))}
      </div>
    </a>
  );
};
